module.exports = __webpack_public_path__ + "static/media/so-algo-duck3.5ab42141.jpg";